import React from 'react';
import PageHeaderTitle from '../PageHeaderTitle';
import PageHeaderDescription from '../PageHeaderDescription';

export default function PageHeader({
  headerTitle,
  headerLogo,
  headerDescription
}) {
  return (
    <div className="app-project-heading">
      <div className="app-container">
        <PageHeaderTitle headerTitle={headerTitle} headerLogo={headerLogo} />
        <PageHeaderDescription headerDescription={headerDescription} />
      </div>
    </div>
  )
}
